import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Dashboard } from './pages/Dashboard';
import { Flow1 } from './pages/Flow1';
import { Flow2 } from './pages/Flow2';
import { Flow3 } from './pages/Flow3';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="h-screen w-screen bg-slate-950 overflow-hidden font-sans" data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Dashboard data-id="element-4" />} data-id="element-3" />
          <Route path="/flow-1" element={<Flow1 data-id="element-6" />} data-id="element-5" />
          <Route path="/flow-2" element={<Flow2 data-id="element-8" />} data-id="element-7" />
          <Route path="/flow-3" element={<Flow3 data-id="element-10" />} data-id="element-9" />
        </Routes>
      </div>
    </BrowserRouter>;
}